import { MachineHistory } from 'models/MachineHistory';
import { ApiPayload } from 'infrastructure/api/ApiTypes';
import { Api } from 'infrastructure/api/Api'
import { push } from 'redux-first-history';

export const MachineHistoryActionType = {
    FETCH_MACHINEHISTORIES: 'FETCH_MACHINEHISTORY',
    FETCH_MACHINEHISTORIES_SUCCESS: 'FETCH_MACHINEHISTORY_SUCCESS',
    ADD_MACHINEHISTORY: 'ADD_MACHINEHISTORY',
    ADD_MACHINEHISTORY_SUCCESS: 'ADD_MACHINEHISTORY_SUCCESS',
    EDIT_MACHINEHISTORY: 'EDIT_MACHINEHISTORY',
    EDIT_MACHINEHISTORY_SUCCESS: 'EDIT_MACHINEHISTORY_SUCCESS',
    DELETE_MACHINEHISTORY: 'DELETE_MACHINEHISTORY',
    DELETE_MACHINEHISTORY_SUCCESS: 'DELETE_MACHINEHISTORY_SUCCESS',
    API_ERROR: 'API_ERROR',
};

interface IFetchMachineHistoriesAction {
    type: typeof MachineHistoryActionType.FETCH_MACHINEHISTORIES
    payload: ApiPayload,
    returnPayload: MachineHistory[],
    meta: {
        isApiCall: boolean
    },
}

interface IAddMachineHistoriesAction {
    type: typeof MachineHistoryActionType.ADD_MACHINEHISTORY
    payload: ApiPayload,
    returnPayload: MachineHistory,
    meta: {
        isApiCall: boolean
    },
}

interface IDeleteMachineHistoriesAction {
    type: typeof MachineHistoryActionType.DELETE_MACHINEHISTORY
    payload: ApiPayload,
    returnPayload: MachineHistory,
    meta: {
        isApiCall: boolean
    },
}

interface IMoveToEditMachineHistory {

}

export type IMachineHistoryActions = IFetchMachineHistoriesAction | IAddMachineHistoriesAction | IDeleteMachineHistoriesAction 
export type IMachineHistoryRedirect = IMoveToEditMachineHistory

const baseUrl = 'api/machineHistories';
export class MachineHistoryActions {
    public static fetchMachineHistories(token: string): IMachineHistoryActions {
        return {
            type: MachineHistoryActionType.FETCH_MACHINEHISTORIES,
            payload: Api.fetchApiCall(baseUrl, token, MachineHistoryActionType.FETCH_MACHINEHISTORIES_SUCCESS, MachineHistoryActionType.API_ERROR),
            returnPayload: [],
            meta: {
                isApiCall: true
            },
        }
    }

    public static addMachineHistory(token: string, machineHistory: MachineHistory): IMachineHistoryActions {
        return {
            type: MachineHistoryActionType.ADD_MACHINEHISTORY,
            payload: Api.postApiCall(baseUrl, token, MachineHistoryActionType.ADD_MACHINEHISTORY_SUCCESS, MachineHistoryActionType.API_ERROR, machineHistory, true),
            returnPayload: MachineHistory.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static moveToEditDailyReport(id: number): IMachineHistoryRedirect {
        return push("/Machines/dailyreport/" + id)
    }

    public static moveToAddDailyReport(): IMachineHistoryRedirect {
        return push("/Machines/dailyreport")
    }

    public static moveToWorkshop(): IMachineHistoryRedirect {
        return push("/Machines/workshop")
    }

    public static moveToEditWorkshop(id: number): IMachineHistoryRedirect {
        return push("/Machines/workshop/" + id)
    }

    public static editMachineHistory(token: string, machineHistory: MachineHistory): IMachineHistoryActions {
        return {
            type: MachineHistoryActionType.EDIT_MACHINEHISTORY,
            payload: Api.putApiCall(baseUrl + '/' + machineHistory.id, token, MachineHistoryActionType.EDIT_MACHINEHISTORY_SUCCESS, MachineHistoryActionType.API_ERROR, machineHistory, true),
            returnPayload: MachineHistory.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

    public static deleteMachineHistory(token: string, id: number): IMachineHistoryActions {
        return {
            type: MachineHistoryActionType.DELETE_MACHINEHISTORY,
            payload: Api.deleteApiCall(baseUrl + '/' + id, token, MachineHistoryActionType.DELETE_MACHINEHISTORY_SUCCESS, MachineHistoryActionType.API_ERROR, true),
            returnPayload: MachineHistory.empty(),
            meta: {
                isApiCall: true
            },
        }
    }

}
